/*
 * People section shell (redesign 2026-10-09, PlunkDocs mockups/people-redesign-2026-10-09.html):
 * one header (title "Customers", a line for the tab, actions) and the Contacts · Dealers or Accounts · Lifecycle tabs.
 * Wholesale workspaces call customers "Dealers": pass customersLabel.
 */
import React from "react";
import { PageHeader, Switcher } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";

// The section is called "Customers", so its account tab reads "Dealers" (wholesale) or "Accounts" (retail).
// Tabs follow the sidebar's rules: the account and Lifecycle tabs need the lifecycle feature.
export function peopleTabs(customersLabel = "Customers") {
  const accounts = customersLabel === "Dealers" ? "Dealers" : "Accounts";
  const lifecycle = hasTenantFeature("lifecycle");
  return [{
    to: "/Contacts",
    label: "Contacts",
    isActive: p => /^\/Contacts/i.test(p)
  }, lifecycle ? {
    to: "/Customers",
    label: accounts,
    isActive: p => /^\/Customers/i.test(p)
  } : null, lifecycle ? {
    to: "/Lifecycle",
    label: "Lifecycle",
    isActive: p => /^\/Lifecycle/i.test(p)
  } : null].filter(Boolean);
}
export const PEOPLE_SUBTITLES = {
  contacts: "Everyone you know, the customers they belong to, and how they move from first visit to order",
  customers: "Every account you sell to, what they buy, and who needs attention",
  dealers: "Every dealer you sell to, what they buy, and who needs attention",
  lifecycle: "How people move from first contact to customer, and who needs a nudge"
};
export default function PeopleShell({
  subtitle,
  actions,
  children,
  cls = "",
  customersLabel = "Customers"
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: `territory-view wa-view people-x ec-form ${cls}`
  }, /*#__PURE__*/React.createElement(PageHeader, {
    title: "Customers",
    subtitle: subtitle,
    chips: [],
    actions: actions
  }), /*#__PURE__*/React.createElement(Switcher, {
    items: peopleTabs(customersLabel),
    ariaLabel: "People views"
  }), children);
}